// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","heroImage":"Header_heroImage__VKvUs","logo":"Header_logo__shVBB"};